import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

const images = [
  '/images/servicio1.jpg',
  '/images/servicio2.jpg',
  '/images/servicio3.jpg',
  '/images/servicio4.jpg',
  '/images/servicio5.jpg',
  '/images/servicio6.jpg',
  '/images/servicio7.jpg',
  '/images/servicio8.jpg',
  '/images/servicio9.jpg',
  '/images/servicio10.jpg',
];

export default function ProjectCarousel() {
  return (
    <section className="relative w-full py-20 overflow-hidden bg-gradient-to-b from-[#050816] via-[#0A0F1F] to-[#050816] z-10">
      {/* Glow effects */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500/20 blur-[140px] rounded-full"></div>

      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-blue-600/20 blur-[140px] rounded-full"></div>

      <div className="relative max-w-8xl mx-auto px-4 md:px-8">
        <div className="mb-14 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white drop-shadow-[0_0_15px_rgba(59,130,246,0.35)]">
            Conozca nuestros proyectos destacados
          </h2>

          <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Soluciones integrales en tecnología, conectividad y seguridad
            empresarial.
          </p>
        </div>

        <Swiper
          modules={[Autoplay, Pagination]}
          slidesPerView={1}
          spaceBetween={20}
          pagination={{ clickable: true }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          loop={true}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <div className="overflow-hidden rounded-6xl shadow-[0_0_40px_rgba(0,140,255,0.12)] border border-cyan-400/10 backdrop-blur-sm">
                <div className="relative group">
                  <img
                    src={image}
                    alt={`Proyecto ${index + 1}`}
                    className="w-full h-[320px] md:h-[75vh] object-cover transition-transform duration-[2500ms] group-hover:scale-110 brightness-[0.75]"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-[#020617] via-[#020617]/30 to-transparent"></div>

                  <div className="absolute bottom-0 left-0 p-6 md:p-10">
                    <p className="text-white text-xl md:text-3xl font-semibold">
                      Somos su aliado tecnológico de confianza
                    </p>

                    <p className="text-gray-300 text-sm md:text-base mt-2">
                      Soluciones tecnológicas profesionales
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
